/**
 * @flow
 * @relayHash 78a9682e34b58d38af15cb872666f0fa
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PasswordResetCompleteInput = {|
  uidb64: string,
  token: string,
  newPassword1: string,
  newPassword2: string,
  clientMutationId?: ?string,
  revisionMessage?: ?string,
|};
export type ResetPasswordCompleteMutationVariables = {|
  input: PasswordResetCompleteInput
|};
export type ResetPasswordCompleteMutationResponse = {|
  +mePasswordResetComplete: ?{|
    +viewer: ?{|
      +id: string,
      +me: ?{|
        +id: string,
        +username: string,
        +avatar: ?{|
          +url: string
        |},
        +isAuthenticated: ?boolean,
        +myPerms: ?$ReadOnlyArray<?string>,
      |},
    |},
    +errors: ?$ReadOnlyArray<?{|
      +code: ?string,
      +location: ?string,
      +message: string,
    |}>,
  |}
|};
export type ResetPasswordCompleteMutation = {|
  variables: ResetPasswordCompleteMutationVariables,
  response: ResetPasswordCompleteMutationResponse,
|};
*/


/*
mutation ResetPasswordCompleteMutation(
  $input: PasswordResetCompleteInput!
) {
  mePasswordResetComplete(input: $input) {
    viewer {
      id
      me {
        id
        username
        avatar(width: 40, height: 40) {
          url
        }
        isAuthenticated
        myPerms
      }
    }
    errors {
      code
      location
      message
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "PasswordResetCompleteInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "mePasswordResetComplete",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PasswordResetCompletePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "me",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "username",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "avatar",
                "storageKey": "avatar(height:40,width:40)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "height",
                    "value": 40
                  },
                  {
                    "kind": "Literal",
                    "name": "width",
                    "value": 40
                  }
                ],
                "concreteType": "File",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isAuthenticated",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "myPerms",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "errors",
        "storageKey": null,
        "args": null,
        "concreteType": "Error",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "code",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "location",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ResetPasswordCompleteMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ResetPasswordCompleteMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ResetPasswordCompleteMutation",
    "id": null,
    "text": "mutation ResetPasswordCompleteMutation(\n  $input: PasswordResetCompleteInput!\n) {\n  mePasswordResetComplete(input: $input) {\n    viewer {\n      id\n      me {\n        id\n        username\n        avatar(width: 40, height: 40) {\n          url\n        }\n        isAuthenticated\n        myPerms\n      }\n    }\n    errors {\n      code\n      location\n      message\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ed79feeb9bafc6697e8a3e5d4c9fe21b';
module.exports = node;
